import { combineReducers, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { createBrowserHistory } from "history";
import { routerMiddleware, connectRouter } from "connected-react-router";

import userStore from "./User/store";

import clientStore from "./client/store";

import consultantStore from "./Consultant/store";

import adminStore from "./admin/store";

import axios from "axios";
import constants from "./constants";

export const history = createBrowserHistory();

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

axios.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem("token");
    request.headers.Authorization = `Bearer ${token}`;
    return request;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return {
      responseStatus: response.status,
      responseBody: response.data,
    };
  },
  (error) => {
    if (error.response.status === constants.status.unAuthorized) {
      history.push("/login");
    }
    if (error.response.status === constants.status.server) {
      history.push("/error");
    }
    return Promise.reject(error);
  }
);

const allStores = combineReducers({
  userStore,
  clientStore,
  consultantStore,
  adminStore,
  router: connectRouter(history),
});

const composedEnhancer = composeWithDevTools(
  applyMiddleware(thunk, routerMiddleware(history))
);

const store = createStore(allStores, composedEnhancer);

export default store;
